import { Api } from '../../typings/api';
import { PendingTasksManagerAction, PendingTasksManagerActionKeys } from './actions';
import Utils from '../../utils';
import UserAgentUtils from '../../utils/userAgent';
import IndexedDBManager from '../../utils/indexedDB/manager';

interface PendingTasksManagerState {
	shares: Api.SharedData[];
}
let initialState: PendingTasksManagerState = {
	shares: [],
};

function pendingTasksManager(
	state: PendingTasksManagerState = initialState,
	action: PendingTasksManagerAction
): PendingTasksManagerState {
	let newPendingTasksManager: PendingTasksManagerState;

	switch (action.type) {
		case PendingTasksManagerActionKeys.INIT_PENDING_TASKS:
			newPendingTasksManager = action.pendingTasks;
			break;
		case PendingTasksManagerActionKeys.CLEAR_PENDING_SHARES:
			newPendingTasksManager = {
				...state,
				shares: []
			};
			break;
		case PendingTasksManagerActionKeys.ADD_PENDING_SHARE:
			newPendingTasksManager = {
				...state,
				shares: [...state.shares, action.pendingShare]
			};
			break;
		default:
			newPendingTasksManager = state;
			break;
	}

	if (Utils.stringIsInStringEnum(action.type, PendingTasksManagerActionKeys) && UserAgentUtils.isMobileApp) {
		IndexedDBManager.setPendingTasks(newPendingTasksManager).then();
	}

	return newPendingTasksManager;
}

export { pendingTasksManager, PendingTasksManagerState };



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/containers/PendingTasksManager/reducer.ts